




















































































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwCardListItem from "./CardListItem.vue";
import iwCardListDraft from "./CardListDraft.vue";
import iwDottedPaginator from "./DottedPaginator.vue";
import { Classified } from "../../interfaces/classified/Classified.interface";
import { MediaQuery } from "../../plugins/responsive/Responsive.interfaces";

export default Vue.extend({

    components: {
        iwCardListDraft: iwCardListDraft,
        iwCardListItem: iwCardListItem,
        iwDottedPaginator: iwDottedPaginator
    },
    props: {
        cards: {
            type: Array,
            required: false,
            default: null as Array<Classified> | null
        },
        amountToShowWidescreen: {
            type: Number,
            required: false,
            default: 4
        },
        amountToShowDesktop: {
            type: Number,
            required: false,
            default: 4
        },
        amountToShowMedium: {
            type: Number,
            required: false,
            default: 3
        },
        amountToShowSmall: {
            type: Number,
            required: false,
            default: 2
        },
        amountToShowXSmall: {
            type: Number,
            required: false,
            default: 2
        },
        background: {
            type: String,
            required: false,
            default: ""
        },
        cardSize: {
            type: String,
            required: false,
            default: "large"
        },
        cardType: {
            type: String,
            required: false,
            default: "card-list-item"
        },
        adding: {
            type: Boolean,
            required: false,
            default: false
        },
        addingType: {
            type: String,
            required: false,
            default: "card-list-draft"
        },
        addingForceDisplay: {
            type: Boolean,
            required: false,
            default: false
        },
        isPaginator: {
            type: Boolean,
            required: false,
            default: false
        },
        paginatorHeight: {
            type: Number,
            default: 32
        },
        seeAllUrl: {
            type: String,
            required: false,
            default: null
        },
    },
    data: function() {
        return {
            uniqueId: uuidv4() as string,
            internalCards:  null as Array<Classified> | null,
            mountedCards: null as Array<Classified> | null, // Card mounted to the dom (On load only the two first page of the card-list are mounted)
            currentAmountToShow: this.amountToShowXSmall as number,
            currentAmountToTranslate: 1 as number,
            cardListWidth: 0 as number, // Width of the list containing all cards
            cardListTranslateX: 0 as number, // Translation X of the list containing all cards
            cardListTranslateXStart: 0 as number, // Translation X of the list on beginning of touchmove
            cardListTranslateActive: 0 as number, // Amount translated during the touchmove
            cardListGutter: 20 as number,
            cardListContainerWidth: 0 as number,
            cardWidth: 0 as number,
            enabledCards: [] as number[],
            addingOffset: 0 as number,
            currentBreakpoint: "x-small" as string,
            firstClientX: 0 as number, // Touch X position when the touch event start
            firstClientY: 0 as number, // Touch Y position when the touch event start
            lastTouchXPosition: 0, // Touch X position when the touch event finish
            paginatorTotalItems: 0 as number,
            paginatorAmountToShow: this.amountToShowXSmall as number,
            isTransitionActive: true as boolean,
            totalTouchDistance: 0 as number,
            totalListPages: 0 as number,
            amountOfDisplayedCard: 0 as number,
            isMobile: true,
            startTouchTime: 0 as number,
            xsmallMediaQueryIndex: {} as MediaQuery | number | void,
            smallMediaQueryIndex: {} as MediaQuery | number | void,
            mediumMediaQueryIndex: {} as MediaQuery | number | void,
            desktopMediaQueryIndex: {} as MediaQuery | number | void,
            widescreenMediaQueryIndex: {} as MediaQuery | number | void
        };
    },

    computed: {
        /**
         * totalCardListTranslateX: The total translation apply on cardlist
         */
        totalCardListTranslateX: function (): number {
            let translation = this.cardListTranslateX + this.cardListTranslateActive as number;

            if (translation <= 0) {
                return 0;
            }

            if (this.currentBreakpoint === "x-small") {
                if (this.cardSize === "large") {
                    if (translation > this.cardListWidth - (this.cardWidth * (this.currentAmountToShow - 1))) {
                        return this.cardListWidth - (this.cardWidth * (this.currentAmountToShow - 1));
                    } else {
                        return translation;
                    }
                }
            }

            if (this.currentBreakpoint === "x-small" || this.currentBreakpoint === "small") {
                if (translation > this.cardListWidth - this.cardWidth) {
                    return this.cardListWidth - this.cardWidth;
                }
            } else {
                if (translation > this.cardListWidth - (this.cardWidth * (this.currentAmountToShow))) {
                    return this.cardListWidth - (this.cardWidth * this.currentAmountToShow);
                }
            }

            return translation;
        },
        /**
         * cardListStyle: All the computed styles applied on cardlist
         */
        cardListStyle: function (): string {
            return "width: " + this.cardListWidth + "px; transform: translate3d(-" + this.totalCardListTranslateX + "px, 0, 0)";
        },
        /**
         * currentListPage: Current page (The number of page depend on the currentAmountToShow)
         */
        currentListPage: function (): number {
            // Medium / Desktop / Widescreen
            let page = Math.round((this.totalCardListTranslateX) / (this.cardWidth * this.currentAmountToShow)) as number;

            if (this.currentBreakpoint === "x-small" || this.currentBreakpoint === "small") {
                page = Math.round((this.totalCardListTranslateX) / this.cardWidth);
            }

            return page;
        },
        /**
         * currentListPosition: The index of the first visible card (max position = number of card)
         */
        currentListPosition: function(): number {
            let position = Math.round((this.totalCardListTranslateX) / this.cardWidth) as number;
            return position;
        },
        /**
         * translatePageAmount: The value of translate for page change
         */
        translatePageAmount: function(): number {
            if(this.currentBreakpoint === "x-small" || this.currentBreakpoint === "small" || this.cardSize === "image") {
                return this.cardWidth;
            } else {
                return this.cardListContainerWidth + this.cardListGutter;
            }
        },
        hasRefreshButtonSlot: function() {
            return !!this.$slots["refresh-button"];
        }
    },

    watch: {
        cards: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.internalCards = newVal as Array<Classified>;
                this.mountedCards = newVal as Array<Classified>;
            }
        }
    },

    beforeMount: function() {
        // Set card
        this.internalCards = this.cards as Array<Classified>;

        // Adapt addingOffset if there is a addingCard
        if(this.adding) {
            this.addingOffset = 1;
        }
    },

    mounted: function () {
        // Register screen resize event
        //window.addEventListener("resize", this.handleResizeScreen);

        // Responsive Behavior
        /* istanbul ignore next */
        // Widescreens
        this.widescreenMediaQueryIndex = this.$responsive.registerMediaQuery("widescreen", () => {
            this.isMobile = false;
            this.currentAmountToTranslate = this.amountToShowWidescreen;
            this.currentAmountToShow = this.amountToShowWidescreen;
            if(this.internalCards !== null) {
                this.paginatorTotalItems = this.internalCards.length - (this.internalCards.length % this.currentAmountToShow);
            }
            this.paginatorAmountToShow = this.currentAmountToShow;
            if (this.cardSize === "image") {
                this.cardListGutter = 0;
            }
            else {
                if(this.cardSize === "small") {
                    this.cardListGutter = 18;
                } else {
                    this.cardListGutter = 20;
                }
            }

            this.currentBreakpoint = "widescreen";

            this.cardListContainerWidth = this.$responsive.containerWidth("widescreen");

            if(this.cardSize === "image") {
                this.cardWidth = 325;
            } else {
                switch(this.cardSize) {
                case "xlarge":
                    this.cardWidth = 560 + this.cardListGutter;
                    break;
                case "large":
                    this.cardWidth = 270 + this.cardListGutter;
                    break;
                default:
                    this.cardWidth = 175 + this.cardListGutter;
                }
            }

            this.init();
            this.resetCardListPosition();
        });

        // Responsive Behavior
        /* istanbul ignore next */
        // Desktop
        this.widescreenMediaQueryIndex  = this.$responsive.registerMediaQuery("desktop", () => {
            this.isMobile = false;
            this.currentAmountToTranslate = this.amountToShowDesktop;
            this.currentAmountToShow = this.amountToShowDesktop;
            if(this.internalCards !== null) {
                this.paginatorTotalItems = this.internalCards.length - (this.internalCards.length % this.currentAmountToShow);
            }

            this.paginatorAmountToShow = this.currentAmountToShow;
            if (this.cardSize === "image") {
                this.cardListGutter = 0;
            } else {
                this.cardListGutter = 20;
            }
            this.currentBreakpoint = "desktop";
            this.cardListContainerWidth = this.$responsive.containerWidth("desktop");
            if(this.cardSize === "image") {
                this.cardWidth = 325;
            } else {
                switch(this.cardSize) {
                case "xlarge":
                    this.cardWidth = 470 + this.cardListGutter;
                    break;
                case "large":
                    this.cardWidth = 225 + this.cardListGutter;
                    break;
                default:
                    this.cardWidth = 176 + this.cardListGutter;
                }
            }

            this.init();
            this.resetCardListPosition();
        });

        // Responsive Behavior
        /* istanbul ignore next */
        // Medium
        this.mediumMediaQueryIndex = this.$responsive.registerMediaQuery("medium", () => {
            this.isMobile = true;
            this.currentAmountToTranslate = this.amountToShowMedium;
            this.currentAmountToShow = this.amountToShowMedium;
            if(this.internalCards !== null) {
                this.paginatorTotalItems = this.internalCards.length - (this.internalCards.length % this.currentAmountToShow);
            }

            this.paginatorAmountToShow = this.currentAmountToShow;
            if (this.cardSize === "image") {
                this.cardListGutter = 0;
            } else {
                this.cardListGutter = 18;
            }

            this.currentBreakpoint = "medium";
            this.cardListContainerWidth = this.$responsive.containerWidth("medium");
            if(this.cardSize === "image") {
                this.cardWidth = this.cardListContainerWidth / 4;
            } else {
                switch(this.cardSize) {
                case "xlarge":
                    this.cardWidth = 351 + this.cardListGutter;
                    break;
                default:
                    this.cardWidth = 228 + this.cardListGutter;
                }
            }

            this.init();
            this.resetCardListPosition();
        });

        // Responsive Behavior
        /* istanbul ignore next */
        // Small
        this.smallMediaQueryIndex = this.$responsive.registerMediaQuery("small", () => {
            this.isMobile = true;
            this.currentAmountToTranslate = 3;
            this.currentAmountToShow = this.amountToShowSmall;
            if(this.internalCards !== null) {
                this.paginatorTotalItems = this.internalCards.length;
            }

            this.paginatorAmountToShow = this.currentAmountToShow;
            if (this.cardSize === "image") {
                this.cardListGutter = 0;
            } else {
                this.cardListGutter = 18;
            }
            this.currentBreakpoint = "small";

            this.cardListContainerWidth = this.$store.getters["responsiveModule/getCurrentWindowWidth"];

            if(this.cardSize === "image") {
                this.cardWidth = this.cardListContainerWidth / 4;
            } else {
                switch(this.cardSize) {
                case "xlarge":
                    this.cardWidth = 272 + this.cardListGutter;
                    break;
                case "large":
                    this.cardWidth = 228 + this.cardListGutter;
                    break;
                default:
                    this.cardWidth = 175 + this.cardListGutter;
                }
            }

            this.init();
            this.resetCardListPosition();
        });

        // Responsive Behavior
        /* istanbul ignore next */
        // x-small
        this.xsmallMediaQueryIndex = this.$responsive.registerMediaQuery("x-small", () => {
            this.isMobile = true;
            this.currentAmountToTranslate = 1;
            this.currentAmountToShow = this.amountToShowXSmall;
            if(this.internalCards !== null) {
                this.paginatorTotalItems = this.internalCards.length;
            }

            this.paginatorAmountToShow = 1;
            if (this.cardSize === "image") {
                this.cardListGutter = 0;
            } else {
                this.cardListGutter = 20;
            }
            this.currentBreakpoint = "x-small";

            this.cardListContainerWidth = this.$store.getters["responsiveModule/getCurrentWindowWidth"];

            if(this.cardSize === "image") {
                this.cardWidth = this.cardListContainerWidth / 4;
            } else {
                switch(this.cardSize) {
                case "xlarge":
                    this.cardWidth = 270 + this.cardListGutter;
                    break;
                case "large":
                    this.cardWidth = 270 + this.cardListGutter;
                    break;
                default:
                    this.cardWidth = 176 + this.cardListGutter;
                }
            }

            this.init();
            this.resetCardListPosition();
        });
    },

    beforeDestroy: function() {
        this.$responsive.unregisterMediaQuery(this.xsmallMediaQueryIndex as number);
        this.$responsive.unregisterMediaQuery(this.smallMediaQueryIndex as number);
        this.$responsive.unregisterMediaQuery(this.mediumMediaQueryIndex as number);
        this.$responsive.unregisterMediaQuery(this.desktopMediaQueryIndex as number);
        this.$responsive.unregisterMediaQuery(this.widescreenMediaQueryIndex as number);
    },

    methods: {
        init: function() {

            Vue.nextTick(() => {
                const cardListContainer = document.getElementById(`card-list-${this.uniqueId}-container`) as HTMLElement;

                if(this.internalCards !== null) {

                    this.totalListPages = Math.round(this.internalCards.length / this.currentAmountToShow);
                    // Only mount the card of the two first pages
                    this.mountedCards = this.internalCards.slice(0, this.currentAmountToShow * 2) as Array<Classified>;

                    this.amountOfDisplayedCard = (Math.floor((this.internalCards.length + this.addingOffset) / this.currentAmountToShow) * this.currentAmountToShow);

                    if (this.amountOfDisplayedCard < this.internalCards.length) {
                        this.amountOfDisplayedCard = this.internalCards.length;
                    }

                    if(this.addingForceDisplay) {
                        this.amountOfDisplayedCard = this.amountOfDisplayedCard + 1;
                    }

                    if (this.internalCards.length) {
                        this.cardListWidth = this.cardWidth * this.amountOfDisplayedCard;
                    } else {
                        this.cardListWidth = this.cardWidth;
                    }
                }

                if (cardListContainer !== null) {
                    // Register event for touch
                    cardListContainer.addEventListener("touchstart", this.handleTouchStart, {
                        passive: true
                    });
                    cardListContainer.addEventListener("touchend", this.handleTouchEnd, {
                        passive: true
                    });
                    cardListContainer.addEventListener("touchmove", this.handleTouchMove, {
                        passive: false
                    });
                }
            });
        },
        /**
         * Display the previous card in the list
         */
        showPreviousCards: function () {
            // Decrease current "page"
            // this.currentListPage = this.currentListPage - 1;

            this.changeCurrentPage(this.currentListPage,"previous");

            // Calculate card list translation
            this.cardListTranslateX = this.cardListTranslateX - this.translatePageAmount;

            // Set enabledCards (card visible and focusable)
            if(this.addingForceDisplay && (this.enabledCards[this.enabledCards.length - 1] === (this.amountOfDisplayedCard - 1))) {
                let amountToTranslate = this.amountOfDisplayedCard % this.currentAmountToTranslate;
                this.enabledCards = this.enabledCards.map(item => item - amountToTranslate);
            } else {
                this.enabledCards = this.enabledCards.map(item => item - this.currentAmountToTranslate);
            }

            this.adjustCardListPosition();
        },
        /**
         * Display the next card in the list
         */
        showNextCards: function () {
            this.changeCurrentPage(this.currentListPage,"next");

            // Mount the next page
            this.mountNextCards();

            // Calculate card list translation
            if (this.currentListPosition >= this.amountOfDisplayedCard - this.currentAmountToShow) {
                this.cardListTranslateX = this.cardListWidth - (this.cardWidth * this.currentAmountToShow);
            } else {
                this.cardListTranslateX = this.cardListTranslateX + this.translatePageAmount;
            }

            // Set enabledCards (card visible and focusable)
            this.enabledCards = this.enabledCards.map(item => item + this.currentAmountToTranslate);
            if(this.addingForceDisplay && (this.enabledCards[this.enabledCards.length - 1] + this.currentAmountToTranslate > this.amountOfDisplayedCard)) {
                let amountToTranslate = this.amountOfDisplayedCard - this.enabledCards[this.enabledCards.length - 1] - 1;
                this.enabledCards = this.enabledCards.map(item => item + amountToTranslate);
            }

            this.adjustCardListPosition();
        },
        /**
         * Mount next classified in the list
         */
        mountNextCards: function(): void {
            if(this.internalCards !== null) {
                this.mountedCards = this.internalCards.slice(0, this.internalCards.length + this.currentAmountToShow) as Array<Classified>;
            }
        },
        /**
         * Reset position of the card list (Show first card of the list)
         */
        resetCardListPosition: function () {
            // this.currentListPage = 0;
            this.cardListTranslateX = 0;
            this.initEnabledCards();
        },
        /**
         * Init the enabledCards (card visible and focusable) based on currentAmountToShow
         */
        initEnabledCards: function () {
            let lastEnabledCard = 0 as number;

            if(this.mountedCards !== null) {
                lastEnabledCard = this.mountedCards.length;
            }

            if (this.currentBreakpoint != "x-small") {
                lastEnabledCard = this.currentAmountToShow;
            } else {
                if (this.cardSize === "small") {
                    // Maximum 2 cards can be show for this breakpoint, let them be focusable
                    lastEnabledCard = 2;
                } else {
                    // Maximum 1 cards can be show for this breakpoint, let them be focusable
                    lastEnabledCard = 1;
                }
            }

            for(let i = 0; i < lastEnabledCard; i++) {
                this.enabledCards.push(i);
            }
        },
        goToItem: function(currentItem: number) {
            // Reset enabled cards
            let newEnabledCards = [] as number[];
            for(let index = 0; index < this.currentAmountToShow; index++) {
                newEnabledCards.push(index);
            }

            if(this.currentListPage !== currentItem) {
                // Set enabledSlides (slide visible and focusable)
                if(this.currentListPage > currentItem) {
                    // Calculate card list translation
                    this.cardListTranslateX = (currentItem * this.translatePageAmount)/this.currentAmountToTranslate;
                }
                else {
                    // Mount the next page
                    if(this.internalCards !== null) {
                        this.mountedCards = this.internalCards.slice(0, currentItem + this.currentAmountToShow) as Array<Classified>;
                    }
                    // Calculate card list translation
                    this.cardListTranslateX = (currentItem * this.translatePageAmount)/this.currentAmountToTranslate;
                }

                // this.currentListPage = currentItem / this.currentAmountToTranslate;
                this.enabledCards = newEnabledCards.map(item => item + currentItem);

                this.changeCurrentPage(this.currentListPage * this.currentAmountToTranslate, "goto");
            }
        },
        changeCurrentPage: function(page: number, action: string) {
            switch(action) {
            case "previous":
                (this.$refs.cardListPaginator as Vue & { previousItem: () => void }).previousItem();
                break;
            case "next":
                (this.$refs.cardListPaginator as Vue & { nextItem: () => void }).nextItem();
                break;
            case "goto":
                (this.$refs.cardListPaginator as Vue & { goToItem(index: number): () => void }).goToItem(page);
                break;
            default:
                break;
            }
        },
        /**
         * Handle Touch Start: Save initial touches position (use to prevent scrollOnSwipe)
         */
        handleTouchStart: function (event: TouchEvent) {
            // Do nothing if there is only one "page"
            if (this.totalListPages >= 1) {
                this.firstClientX = event.touches[0].clientX;
                this.firstClientY = event.touches[0].clientY;
                this.lastTouchXPosition = this.firstClientX;
                // Record time when finger first makes contact with surface
                this.startTouchTime = new Date().getTime() as number;

                this.cardListTranslateXStart = this.cardListTranslateX;

                this.isTransitionActive = false;
            }
        },
        /**
         * Handle Touch End
         */
        handleTouchEnd: function () {
            // Do nothing if there is only one "page"
            if (this.totalListPages >= 1) {

                const swipeThreshold = 50; // Minimum distance required to be considered a swipe
                const swipeAllowedTime = 300; //  Maximum time allowed to be considered a swipe

                this.totalTouchDistance = this.lastTouchXPosition - this.firstClientX;

                // Get the touch direction (-1: from right to left, 1 from left to right, 0: no move)
                const swipeTouchDirection = Math.sign(this.totalTouchDistance);

                // Get time elapsed during the touch
                const elapsedTime = new Date().getTime() - this.startTouchTime as number;

                // Test if the movement is a "swipe"
                const isASwipe = (elapsedTime <= swipeAllowedTime && Math.abs(this.totalTouchDistance) >= swipeThreshold);

                // Set back transition
                this.isTransitionActive = true;

                if (isASwipe === true) {
                    // Is a swipe
                    if (swipeTouchDirection === -1) {
                        // Swipe left (from right to left), show next cards
                        this.handleSwipeLeft();
                    } else if (swipeTouchDirection === 1) {
                        // Swipe Right (from left to right), show previous cards
                        this.handleSwipeRight();
                    }

                } else {
                    // Not a swipe, handle like a simple slide
                    this.cardListTranslateX = this.totalCardListTranslateX;
                    this.adjustCardListPosition();
                }
            }
        },
        /**
         * Handle Touch move
         */
        handleTouchMove: function (event: TouchEvent) {
            // Do nothing if there is only one "page"
            if (this.totalListPages >= 1) {
                // Get the horizontal and vertical distance of a touch movement
                const slideXDistance = event.touches[0].clientX - this.firstClientX;
                const slideYDistance = event.touches[0].clientY - this.firstClientY;

                this.lastTouchXPosition = event.touches[0].clientX;

                // Get current page
                var previousCurrentListPage = this.currentListPage;

                var isVerticalScrollEnable = true;

                // If the horizontal distance is bigger than the vertical (slide horizontal) cancel the vertical scroll
                if((Math.abs(slideXDistance) > Math.abs(slideYDistance)) && event.cancelable) {
                    event.preventDefault();
                    event.returnValue = false;
                    // return false;
                    isVerticalScrollEnable = false;
                }

                // If the vertical scroll is disable, translate the cardList
                if(isVerticalScrollEnable === false) {
                    this.cardListTranslateActive = -slideXDistance;
                }

                // Test if we should mount next classified
                if (this.currentListPage > previousCurrentListPage) {
                    this.mountNextCards();
                }
            }
        },
        /**
         * Handle Swipe Left
         */
        handleSwipeLeft: function (): void {
            this.showNextCards();
        },
        /**
         * Handle Swipe Right
         */
        handleSwipeRight: function (): void  {
            this.showPreviousCards();
        },
        /**
         * adjustCardListPosition: Adjust the cardlist position to make sure the card are correctly aligned
         */
        adjustCardListPosition: function() {
            // Reset active translation
            this.cardListTranslateActive = 0;

            // Test if the cardlist stop on a correct position
            const rest = this.totalCardListTranslateX % this.cardWidth;

            if(!this.addingForceDisplay) {
                if (rest !== 0 && rest !== this.cardWidth && this.internalCards !== null) {
                    if (this.currentListPosition >= this.internalCards.length - 1) {
                        this.cardListTranslateX = (this.cardListWidth - this.cardWidth);
                    } else {
                        this.cardListTranslateX = this.currentListPosition * this.cardWidth;
                    }
                }
            }
        },
        /**
         * Handle Key Left (show previous page)
         */
        handleKeyLeft: function() {
            if (this.currentListPage !== 0) {
                this.showPreviousCards();
            }
        },
        /**
         * Handle Key Right (show next page)
         */
        handleKeyRight: function() {
            if (this.currentListPage < (this.amountOfDisplayedCard / this.currentAmountToTranslate) - 1) {
                this.showNextCards();
            }
        }
    }
});

